$(function () {
  if (!$('.salaries_graph_wrapper').length) return;

  const url = $('.salaries_graph_wrapper').data('url');
  $.ajax({
    type: 'GET',
    url,
    datatype: 'script',
  });
});
